import './Menu.css'
import React, { useState } from 'react'
import Sidebar from '../../Components/SideBar/index'
import ScrollToTop from '../../Components/ScrollToTop'
import Index2 from '../../Components/Navbar2/index2'
import Footer from '../../Components/Footer/Footer'
import InfoSection3 from '../../Components/Infosection3/Index3'
import { homeObjOne3 } from '../../Components/Infosection3/Data3'

const Breakfast = () => {
  const [isOpen, setIsOpen] = useState(false)
      
     const toggle = () => {
      setIsOpen(!isOpen)
     }
  return (
    <>
      <ScrollToTop />
      <div className='HeroContainer_menu'>
        <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='Hero_menu'>
          <Index2 toggle={toggle}/>
        </div>
      </div>
      <InfoSection3 {...homeObjOne3}/>
      <div className='menu_con'>
        <div className='menu_title'>
          Vår Meny
        </div>
      </div>
      <div className='menu'>
        <div className='menu_pic'>
          <div className='grid-container'>
            <div className='card_con'>
                <div className='wrapper'>
                <br /><br />
                    <div className='card_area'>
                        <div className='card'>
                        <div className='meny_title'>
                            Classic Breakfast – 139 kr/person
                        </div><br /><br />
                        <div className='menu_mat'>
                            Fralla, 
                            <br /><br />
                            ost, 
                            <br /><br />
                            skinka/kalkon, 
                            <br /><br />
                            grönsaker, 
                            <br /><br />
                            frukt, 
                            <br /><br />
                            juice, 
                            <br /><br />
                            kaffe & te
                            <br /><br />
                        </div>
                        </div>
                        <div className='card'>
                        <div className='meny_title'>
                            Healthy Breakfast – 159 kr/person
                      </div><br /><br />
                      <div className='menu_mat'>
                        Yoghurt med granola & bär, 
                        <br /><br />
                        fruktsallad, 
                        <br /><br />
                        overnight oats, 
                        <br /><br />
                        smoothie, 
                        <br /><br />
                        kaffe & te
                        <br /><br />
                      </div> 
                    </div>              
                    <div className='card'>
                        <div className='meny_title'>
                        Luxury Breakfast – 199 kr/person
                        </div><br /><br />
                    <div className='menu_mat'>
                        Premiumfrallor, 
                        <br /><br />
                        mini-croissanter, 
                        <br /><br />
                        yoghurt med granola & färska bär, 
                        <br /><br />
                        fruktsallad, 
                        <br /><br />
                        smoothie, 
                        <br /><br />
                        juice, 
                        <br /><br />
                        kaffe & te
                        <br /><br />
                    </div>
                    </div>
                    <div className='card'>
                    <div className='meny_title'>
                        FRALLOR & SMÖRGÅSAR
                        </div><br /><br />
                        <div className='menu_mat'>
                            Ost & skinka – 59 kr
                            <br /><br />
                            Kalkon & färskost – 59 kr
                            <br /><br />
                            Kyckling & pesto – 69 kr
                            <br /><br />
                            Salami & brie – 69 kr
                            <br /><br />
                            Mozzarella, tomat & pesto – 65 kr
                            <br /><br />
                            Avokado & hummus – 65 kr
                            <br /><br />
                            Tonfiskröra – 69 kr
                            <br /><br />
                            Räkor & ägg – 79 kr
                            <br /><br />
                        </div>
                        </div>
                        <div className='card'>
                        <div className='meny_title'>
                            FIKA
                        </div><br /><br />
                        <div className='menu_mat'>
                            Kanelbulle – 35 kr
                            <br /><br />
                            Kardemummabulle – 35 kr
                            <br /><br />
                            Croissant – 39 kr
                            <br /><br />
                            Muffin – 35 kr
                            <br /><br />
                            Cookie – 30 kr
                            <br /><br />
                            Brownie – 39 kr
                            <br /><br />
                            Morotskaka – 39 kr
                            <br /><br />
                            Frukt – 35 kr
                            <br /><br />
                            Fruktsallad – 49 kr
                            <br /><br />
                            Mini-bakverk – 45 kr
                            <br /><br />
                        </div>
                        </div>
                        <div className='card'>
                            <div className='meny_title'>
                                DRYCK
                            </div><br /><br />
                        <div className='menu_mat'>
                            Kaffe – 25 kr/person
                            <br /><br />
                            Te – 25 kr/person
                            <br /><br />
                            Juice – 25 kr/person
                            <br /><br />
                            Smoothie – 39 kr/person
                            <br /><br />
                            Mineralvatten – 20 kr/person
                            <br /><br />
                            Läsk – 25 kr/person
                            <br /><br />
                        </div>
                        </div>
                        
                  </div>             
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  )
}

export default Breakfast